import React, { Component } from 'react';
import AlbumArt from './AlbumArt';
import AmazonLink from './AmazonLink';

class RecentlyPlayed extends Component {

    amazonLink(artist, title){
        return 'https://www.amazon.com/gp/search?ie=UTF8&keywords='+encodeURIComponent(artist)+'-'+encodeURIComponent(title)+'&tag=cust-chan-20&index=digital-music-track&linkCode=ur2&camp=1789&creative=9325';
    }

    render() {
        var self = this;
        return (
            <div className="recently-played">
                { this.props.tracks.map(function(track, i){
                    var rowType = (i % 2 === 0 ? '' : 'odd');
                    return (
                    <div className={ rowType + " recently-played-row" } key={ i }>
                        <div>
                            <AlbumArt albumArtUrl={ track.album_art.small } album={ track.album } />
                        </div>
                        <div className="recently-played-track-meta">
                            <span className="track-info">"{ track.title }" - { track.album }</span> <br />
                            <span className="artist-name">{ track.artist }</span>
                        </div>
                        <div>
                            <AmazonLink track={ track.title } artist={ track.artist } />
                        </div>
                    </div>
                    );
                })}
            </div>
        );
    }
}

export default RecentlyPlayed;



// WEBPACK FOOTER //
// ./src/RecentlyPlayed.js